import Brands from "src/assets/popup/Brands.png";
import { useEffect } from "react";
import CloseIcon from "./CloseIcon";
import { Button } from "../ui/button";

const ShopPopup = ({ handleClose }: { handleClose: () => void }) => {
  useEffect(() => {
    const html = document.getElementsByTagName("html")[0];

    html.classList.add("overflow-hidden");
    return (): void => {
      html.classList.remove("overflow-hidden");
    };
  }, []);

  const handleClick = () => {
    window.open("https://www.dein-merci.de/", "_blank");
    handleClose();
  };

  return (
    <div className="fixed bg-black bg-opacity-20 z-20 w-[100vw] h-[100vh] flex justify-center">
      <div className="flex flex-col justify-center">
        <div className="bg-white w-[calc(100vw-60px)] md:w-[620px] md:h-[434px] px-2">
          <div className="flex justify-end mt-6 mr-4">
            <a className="cursor-pointer" onClick={handleClose}>
              <CloseIcon />
            </a>
          </div>
          <div className="flex flex-col items-center gap-4">
            <div className="max-w-full md:w-[460px]">
              <img src={Brands} alt="Storck Brands" className="max-w-full" />
            </div>
            <div className="text-[28px] leading-[30px] font-bold mb-6">
              Zum dein-merci Onlineshop von
              <br />
              Traffic Print Online Solutions
            </div>
            <div className="mb-6" onClick={handleClick}>
              <Button className="bg-[#f73d30] hover:bg-[#f73d30] outline-0">
                Weiterleiten
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopPopup;
